import ConfigService from './ConfigService'
import BaseService from './BaseService'

export default new (class ContactService extends BaseService {
  constructor() {
    super({
      baseURL: () => ConfigService.get('api.contact')
    })
  }

  send(data) {
    if (data.zipCode) {
      data.zipCode = parseInt(data.zipCode)
    }
    if (!data.topic) {
      delete data.topic
    }

    return this.post('', data).catch(error => {
      const { data, status } = error.response

      if (status === 400) {
        return Promise.reject({ fieldErrors: data || [] })
      }

      return Promise.reject(error)
    })
  }
})()
